<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }" :style="{
    backgroundColor: leftMenuStyle('backgroundColor') || '#34495e',
    padding: !collapse ? '14px' : '0px'
  }">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link"
        :style="{ justifyContent: collapse ? 'center' : 'flex-start' }">
        <img :src="$collapseLogo ? $collapseLogo : $appLogo" class="sidebar-logo" :onerror="`this.src='${$defaultLogo}'`" />
      </div>
      <div v-else key="expand" class="sidebar-logo-link" to="/">
        <div v-if="$appLogo"><img :src="$appLogo" class="sidebar-logo" :onerror="`this.src='${$defaultLogo}'`" /></div>
      </div>
    </transition>
  </div>
</template>

<script>
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },

  methods: {
    leftMenuStyle(key) {
      const leftMenuStyle = globalParams.get("leftMenuStyle") || {};
      return leftMenuStyle[key];
    },

    collapseLogo() {
      try {
        require("@/CommonDP/assets/collapseLogo.png");
        return true;
      } catch (e) {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 50px;
  box-sizing: border-box;
  overflow: hidden;
  transition: 0s;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    transition: 0s;
    display: flex;
    align-items: center;
    & .sidebar-logo {
      vertical-align: middle;
      margin-right: 10px;
      transition: 0s;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 22px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
